/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui";
import {
  useSaveCall,
  useGetTicketDetails,
  useSubmitTicket,
  useCreateCall,
} from "services/tickets";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import {
  useLookupAllAssignmentGroups,
  useLookupCategories,
  useLookupCustomers,
  useLookupGetEmployeeDetail,
  useLookupGetEmployees,
  useLookupSubCategories,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import { useGetAssignee, useGetEmployeeDetails } from "services/auth";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useGetCustomerDetails } from "services/customers";
import CustomerDetails from "../common/customer-details";
import { emptyTicket } from "../constants";
import UserDetails from "../common/user-details";
import { useUser } from "hooks/use-user";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { getLocalISODateString } from "utils/date-utils";

const emptyRequest = {
  ...emptyTicket,
  activityType: "Voice Of Staff",
  assignmentGroup: "Cash Admin",
};
export default function CreateVoiceOfStaffTicket() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const [allAssignmentGroups, setAllAssignmentGroups] = useState([]);
  const [employeeTgId, setEmployeeTgId] = useState(null);
  const user = useUser();
  const params = useParams();
  const navigate = useNavigate();
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getEmployees,
    data: employeesListRes,
    isPending: gettingEmployeesList,
  } = useLookupGetEmployees();
  const {
    mutate: getEmployeeDetails,
    data: employeeDetailRes,
    isPending: gettingEmployeeDetail,
    reset: resetEmployeeDetails,
  } = useLookupGetEmployeeDetail();

  const {
    mutate: getCategories,
    data: categoriesRes,
    isPending: gettingCategories,
  } = useLookupCategories();
  const {
    mutate: getSubCategories,
    data: subCategoriesRes,
    isPending: gettingSubCategories,
  } = useLookupSubCategories();

  const {
    mutate: getAllAssignmentGroups,
    data: allAssignmentGroupRes,
    isPending: gettingAllAssignmentGroup,
    reset: resetAllAssignmentGroups,
  } = useLookupAllAssignmentGroups();
  const {
    mutate: getAssigneeList,
    data: assigneeListRes,
    isPending: gettingAssigneeList,
  } = useGetAssignee();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useCreateCall();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSaveCall();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
    reset: resetSubmitTicket,
  } = useSubmitTicket();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();

  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    error: customerDetailsError,
    // reset: customerDetailsReset,
  } = useGetCustomerDetails();

  const {
    mutate: getUserDetails,
    data: userDetailsRes,
    // isPending: gettingUserDetails,
    error: userDetailsError,
    // reset: userDetailsReset,
  } = useGetEmployeeDetails();

  const form = useForm({
    defaultValues: { ...emptyRequest },
    mode: "onSubmit",
  });
  useEffect(() => {
    getCustomersList();
    onActivityTypeChange("Voice Of Staff");
    getEmployees();
    getAllAssignmentGroups();
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  // useEffect(() => {
  //   if (form.watch("region") && form.watch("assignmentGroup")) {
  //     getAssigneeList({
  //       region: form.getValues("region"),
  //       assignment: form.getValues("assignmentGroup"),
  //     });
  //   }
  // }, [form.watch("region"), form.watch("assignmentGroup")]);

  useEffect(() => {
    if (customersListRes?.data) {
      form.setValue(
        "customerId",
        customersListRes?.data.find(
          (elm) => elm.name === "Transguard Group (TG)",
        )?.customerId || "",
      );
    }
  }, [customersListRes]);

  useEffect(() => {
    if (ticketDetailsRes && customersListRes && employeesListRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = {
          ...ticketDetailsRes.data,
          alertDateTime: ticketDetailsRes.data.alertDateTime
            ? new Date(ticketDetailsRes.data.alertDateTime)
            : null,
          isCustomerComplaint: ticketDetailsRes.data.isCustomerComplaint
            ? "Yes"
            : "No",
        };

        form.reset({
          ...emptyRequest,
          region: _details.state,
          ..._details,
          alertDateTime: _details.alertDateTime
            ? new Date(_details.alertDateTime)
            : null,
        });

        if (ticketDetailsRes.data.activityType) {
          getCategories(ticketDetailsRes.data.activityType);
        }
        if (ticketDetailsRes.data.category) {
          getSubCategories({
            activityType: ticketDetailsRes.data.activityType,
            category: ticketDetailsRes.data.category,
          });
        }
        getCustomerDetails(_details.customerId);
        setTicketDetails({ ..._details });

        const employee = employeesListRes?.data.find(
          (elm) => elm.id === _details.employeeId,
        );
        if (employee) {
          onEmployeeChange(employee.id);
          form.setValue("reportedBy", employee.id);
        }

        resetDetailsApi();
      }
    }

    if (createTicketRes) {
      if (createTicketRes.status && createTicketRes.status === 200) {
        resetCreateTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset();
      }
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (saveTicketRes) {
      if (saveTicketRes.status && saveTicketRes.status === 200) {
        sweetAlert({
          title: "Operation Successful!",
          text: "Ticket Has Been Saved",
          icon: "success",
        });
        resetSaveTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset();
      }
    }
    if (saveTicketError) {
      resetSaveTicket();
    }

    if (submitTicketRes) {
      if (submitTicketRes.status && submitTicketRes.status === 200) {
        resetSubmitTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset({ ...emptyRequest });
      }
    }
    if (submitTicketError) {
      resetSubmitTicket();
    }

    if (allAssignmentGroupRes) {
      setAllAssignmentGroups(
        (allAssignmentGroupRes?.data || []).filter((elm) => {
          if (["Cash Admin"].includes(elm.name)) {
            return true;
          }
          return false;
        }),
      );
      resetAllAssignmentGroups();
    }
    if (employeeDetailRes) {
      const employee = employeeDetailRes.data;

      const employeeKeys = Object.keys(employee);
      employeeKeys.forEach((element) => {
        form.setValue(element, employee[element]);
      });
      setEmployeeTgId(employee.tgId);
      resetEmployeeDetails();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    saveTicketError,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
    allAssignmentGroupRes,
    employeeDetailRes,
    employeesListRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    alertDateTime: { required: "Please Select Date & Time" },
    customerId: { required: "Please Enter Value" },
    customerTicketNo: {
      pattern: {
        value: /^[A-Za-z0-9\s]+$/,
        message: "Invalid Pattern(Only Alphanumeric Allowed)",
      },
    },
    activityType: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    assigneeId: { required: "Please Enter Value" },
    creationChannel: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };
  const createTicketPayload = () => {
    const _data = form.getValues();
    const payload = {
      alertDateTime: getLocalISODateString(_data.alertDateTime),
      customerId: _data.customerId,
      activityType: _data.activityType,
      category: _data.category,
      subCategory: _data.subCategory,
      creationChannel: "Web",
      assignmentGroup: _data.assignmentGroup,
      priority: 0,
      reportedBy: _data.employeeName,
      requesterEmail: _data.email,
      requesterContactNo: _data.contactNumber,
      employeeId: _data.id,
      employeeTgId,
      employeeName: _data.employeeName,
      employeeTgId,
      businessUnit: _data.businessUnit,
      department: _data.department,
      contract: _data.camp,
      reportingTo: _data.reportingTo,
      remarks: _data.remarks,
      region: _data.region,
    };
    return payload;
  };
  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      ...createTicketPayload(),
    };
    submitTicket({ ...payload });
  };
  const onCancel = () => {};
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    createTicket(createTicketPayload());
    // const data = form.getValues();
    // verifyTicket({
    //   assetId: data.assetId,
    //   customerTicketNo: data.customerTicketNo,
    //   activityType: data.activityType,
    //   category: data.category,
    // });
  };

  const onSaveAsDraft = () => {
    const payload = {
      ...createTicketPayload(),
    };
    saveTicket({ ...payload });
  };
  const onCustomerChange = (data) => {
    form.setValue("assetId", "");
    form.setValue("locationName", "");
    form.setValue("region", "");
    form.setValue("assignmentGroup", "");
    form.setValue("assigneeId", "");
    getCustomerDetails(data);
  };
  const onEmployeeChange = (data) => {
    getEmployeeDetails(data);
  };

  const onAssignmentGroupChange = () => {
    form.setValue("assigneeId", "");
    form.setValue("secondaryAssigneeId", "");
  };

  const onActivityTypeChange = (data) => {
    getCategories(data);
  };
  const onCategoryChange = (data) => {
    form.setValue("subCategory", "");
    getSubCategories({
      activityType: form.getValues("activityType"),
      category: data,
    });
  };

  function AccountDetails() {
    if (customerDetailsError && customerDetailsError?.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("customerId") || !customerDetailsRes) {
      return <>Select Account To Show Data</>;
    }

    return <CustomerDetails customer={customerDetailsRes.data} />;
  }

  function EmployeeDetails() {
    if (userDetailsError && userDetailsError.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("assigneeId") || !userDetailsRes) {
      return <>Select Assignee To Show Data</>;
    }

    return <UserDetails user={userDetailsRes.data} />;
  }

  return (
    <>
      {gettingCustomersList ||
      gettingAssigneeList ||
      savingTicket ||
      creatingTicket ||
      gettingAssigneeList ||
      gettingCategories ||
      gettingTicket ||
      submittingTicket ||
      gettingCustomerDetails ||
      gettingAllAssignmentGroup ||
      gettingEmployeesList ||
      gettingEmployeeDetail ||
      gettingSubCategories ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <Breadcrumb className="mt-5 text-black">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink>
                <Link to={PATHS.openTickets} className="text-black">
                  Tickets
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-black" />

            <BreadcrumbItem>
              <BreadcrumbPage className="text-black">
                Create Ticket
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex flex-row justify-end w-full gap-2">
          {form.watch("status") !== "Draft" ? (
            <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
              Save
            </Button>
          ) : (
            <Button variant="secondary" onClick={form.handleSubmit(onSubmit)}>
              Submit
            </Button>
          )}

          <Button
            variant="secondary"
            onClick={form.handleSubmit(onSaveAsDraft)}
          >
            Save As Draft
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>

          <Link to={PATHS.openTickets}>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Link>
        </div>
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Voice of Staff</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormField
                    control={form.control}
                    name="alertDateTime"
                    rules={verificationRules.alertDateTime}
                    render={({ field }) => (
                      <FormItem>
                        <Label label="Alert Date & Time" isRequired />
                        <div className="form-date-picker">
                          <FormControl>
                            <DateTimePicker
                              variant="secondary"
                              className="px-3 py-2 border border-secondary rounded-md"
                              value={field.value}
                              placeholder="Select Date & Time"
                              onChange={(e) => {
                                field.onChange(e.target.value);
                              }}
                            />
                          </FormControl>
                          {form.formState.errors.alertDateTime ? (
                            <p className="text-destructive text-xs">
                              {form.formState.errors.alertDateTime.message}
                            </p>
                          ) : null}
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="form-row-d-50">
                  <FormDropdown
                    {...generalProps}
                    label="Account"
                    name="customerId"
                    isRequired
                    disabled
                    data={customersListRes?.data || []}
                    text="name"
                    id="customerId"
                    placeholder="Select Account"
                    rules={verificationRules.customerId}
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="businessUnit"
                    label="Business Unit"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Reported By"
                    name="reportedBy"
                    isRequired
                    data={
                      employeesListRes?.data.map((elm) => ({
                        ...elm,
                        name: `${elm.tgId}-${elm.employeeName}`,
                      })) || []
                    }
                    text="name"
                    id="id"
                    placeholder="Select Employee"
                    rules={verificationRules.customerId}
                    onChange={onEmployeeChange}
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="department"
                    label="Department"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Activity Type"
                    name="activityType"
                    isRequired
                    placeholder="Select Type"
                    data={[]}
                    text="description"
                    id="description"
                    rules={verificationRules.activityType}
                    onChange={onActivityTypeChange}
                    disabled
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="camp"
                    label="Contracts"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Category"
                    name="category"
                    isRequired
                    placeholder="Select Category"
                    data={categoriesRes?.data || []}
                    text="description"
                    id="description"
                    rules={verificationRules.category}
                    onChange={onCategoryChange}
                  />{" "}
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="contactNumber"
                    label="Contact Number"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Sub Category"
                    name="subCategory"
                    isRequired
                    placeholder="Select Sub Category"
                    rules={verificationRules.subCategory}
                    data={subCategoriesRes?.data || []}
                    text="description"
                    id="description"
                    info={
                      form.watch("activityType") && form.watch("category")
                        ? ""
                        : "Select Category To Load Data"
                    }
                  />{" "}
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="email"
                    label="Email Id"
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Assignment Group"
                    name="assignmentGroup"
                    // isRequired={true}
                    // disabled={
                    //   !form.watch("assetId") || !form.watch("activityType")
                    // }
                    placeholder="Select Assignment Group"
                    data={allAssignmentGroups || []}
                    text="name"
                    id="name"
                    onChange={onAssignmentGroupChange}
                    // rules={verificationRules.assignmentGroup}
                  />{" "}
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="reportingTo"
                    label="Reporting To"
                  />
                  <FormInput
                    {...generalProps}
                    // isRequired={true}
                    inputProps={{ readOnly: true }}
                    name="region"
                    label="Region"
                  />
                  {/* <FormInput
                    {...generalProps}
                    // isRequired={true}
                    name="correlationId"
                    label="Correlation Id"
                    // rules={verificationRules.correlationId}
                  /> */}
                  {/* {form.watch("customerId") === "66e42d5af405de06de469b79" ? (
                    <FormInput
                      {...generalProps}
                      // isRequired={true}
                      name="secondaryAssigneeId"
                      label="Secondary Assignee Id"
                    />
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
